import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    const res = await login(email, password);
    setBusy(false);
    if (res.ok) {
      const from = location.state?.from?.pathname || "/";
      navigate(from, { replace: true });
    } else {
      setError(res.error);
    }
  };

  return (
    <div data-testid="login-page" className="mx-auto grid max-w-md px-4 py-16">
      <div className="rounded-3xl border border-line bg-white p-8">
        <div className="text-[11px] font-bold uppercase tracking-[0.24em] text-muted-soft">Вход</div>
        <h1 className="mt-2 text-3xl font-extrabold tracking-tightest text-ink">С возвращением</h1>
        <p className="mt-2 text-sm text-muted">Войдите в аккаунт vip77.store, чтобы продолжить.</p>

        <form onSubmit={submit} className="mt-8 space-y-4">
          <label className="block">
            <span className="mb-1 block text-xs font-semibold text-muted">Email</span>
            <input
              required
              type="email"
              data-testid="login-email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full rounded-lg border border-line bg-white px-4 py-3 text-sm outline-none focus:border-ink"
            />
          </label>
          <label className="block">
            <span className="mb-1 block text-xs font-semibold text-muted">Пароль</span>
            <input
              required
              type="password"
              data-testid="login-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full rounded-lg border border-line bg-white px-4 py-3 text-sm outline-none focus:border-ink"
            />
          </label>
          {error && (
            <div data-testid="login-error" className="rounded-lg bg-danger/10 px-3 py-2 text-sm text-danger">
              {error}
            </div>
          )}
          <button
            data-testid="login-submit"
            disabled={busy}
            type="submit"
            className="w-full rounded-full bg-ink py-3 text-sm font-semibold text-white transition-colors hover:bg-ink-soft disabled:opacity-50"
          >
            {busy ? "Входим…" : "Войти"}
          </button>
        </form>

        <div className="mt-6 text-center text-sm text-muted">
          Нет аккаунта?{" "}
          <Link to="/register" className="font-semibold text-ink underline-offset-4 hover:underline">
            Зарегистрироваться
          </Link>
        </div>
        <div className="mt-2 text-center text-xs">
          <Link to="/forgot-password" data-testid="forgot-link" className="text-muted underline-offset-4 hover:text-ink hover:underline">
            Забыли пароль?
          </Link>
        </div>

        {/* Demo credentials moved to /memory/demo_credentials.md */}
      </div>
    </div>
  );
}
